import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {NavItem} from '../../../../models/nav-item.model';
import {Store} from '@ngxs/store';
import {NavService} from '../../../../services/nav.service';
import {NavItemCodes} from '../../../../enums/nav-item-codes.enum';

@Component({
    selector: 'app-nav-link',
    templateUrl: './nav-link.component.html',
    styleUrls: ['./nav-link.component.less']
})
export class NavLinkComponent implements OnChanges {
    @Input() label: string;
    @Input() payload: any;
    @Input() tooltip: string;
    @Input() disabled = false;
    @Input() textOnDisabled = false;
    @Input() code: NavItemCodes;

    navItem: NavItem;

    constructor(
        private store: Store,
        private navService: NavService,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.code) {
            this.navItem = NavService.get(this.code);
        }
    }

    onClick() {
        if (this.navItem) {
            this.navService.handleDispatch(this.navItem, this.payload);
        }
    }

}
